import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Image from "react-bootstrap/Image"
import { GoogleLogin, GoogleLogout } from "react-google-login"
import { goggleAuthClientID } from "../../appsettings"
import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState } from 'react';

const ConfirmNavigationDialog = ({ isOpen, onCancel, onConfirm }) => (
	isOpen && (
		<div style={{
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: 'rgba(0,0,0,0.5)',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			zIndex: 1100
		}}>
			<div style={{
				background: 'white',
				padding: '24px',
				borderRadius: '12px',
				boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
				maxWidth: '400px',
				width: '90%'
			}}>
				<h3 style={{ 
					marginBottom: '16px',
					color: '#333',
					fontSize: '18px'
				}}>
					Unsaved Changes
				</h3>
				<p style={{
					marginBottom: '24px',
					color: '#666',
					lineHeight: '1.5'
				}}>
					Your current work will not be saved. Are you sure you want to proceed?
				</p>
				<div style={{
					display: 'flex',
					gap: '12px',
					justifyContent: 'flex-end'
				}}>
					<button
						onClick={onCancel}
						style={{
							padding: '8px 16px',
							background: 'white',
							border: '1px solid #e0e0e0',
							borderRadius: '6px',
							cursor: 'pointer',
							color: '#666'
						}}
					>
						Stay
					</button>
					<button
						onClick={onConfirm}
						style={{
							padding: '8px 16px',
							background: '#4a86e8',
							color: 'white',
							border: 'none',
							borderRadius: '6px',
							cursor: 'pointer'
						}}
					>
						Proceed
					</button>
				</div>
			</div>
		</div>
	)
);

const NavigationBar = ({
	userProfile, 
	anonymousUserId,
	researchId, 
	onAuthSuccess, 
	onAuthFailure, 
	logoutFunction,
	projectMode,
	hasUploadedMap
}) => {
	const [showConfirmDialog, setShowConfirmDialog] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	const handleNavigation = (path) => {
		if (hasUploadedMap && location.pathname === '/') {
			setShowConfirmDialog(true);
		} else {
			navigate(path);
		}
	};

	return (
		<>
			<Navbar style={{
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				zIndex: 1000,
				background: 'white',
				boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
				padding: '12px 0'
			}}>
				<Container>
					<Navbar.Brand style={{
						color: '#333',
						fontSize: '20px',
						fontWeight: '600',
						letterSpacing: '-0.5px'
					}}>
						Map Resource
					</Navbar.Brand>
					
					{userProfile && researchId ? (
						<>
							<Nav 
								variant="underline" 
								activeKey={location.pathname}
								style={{
									gap: '8px'
								}}
							>
								<Nav.Item>
									<Nav.Link 
										onClick={() => handleNavigation('/')}
										active={location.pathname === '/'}
										style={{
											color: location.pathname === '/' ? '#4a86e8' : '#666',
											fontWeight: '500',
											padding: '8px 16px',
											borderBottom: location.pathname === '/' ? '2px solid #4a86e8' : '2px solid transparent',
											transition: 'all 0.2s ease'
										}}
									>
										Map Editor
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link 
										onClick={() => handleNavigation('/saved-maps')}
										active={location.pathname === '/saved-maps'}
										style={{
											color: location.pathname === '/saved-maps' ? '#4a86e8' : '#666',
											fontWeight: '500',
											padding: '8px 16px',
											borderBottom: location.pathname === '/saved-maps' ? '2px solid #4a86e8' : '2px solid transparent',
											transition: 'all 0.2s ease'
										}}
									>
										Library
									</Nav.Link>
								</Nav.Item>
							</Nav>

							<div style={{ 
								display: 'flex', 
								alignItems: 'center',
								gap: '16px'
							}}>
								<span style={{
									color: '#666',
									fontSize: '14px'
								}}>
									ID: {researchId}
								</span>
								<NavDropdown 
									title={
										<Image 
											src={userProfile.imageUrl} 
											roundedCircle
											style={{
												height: "40px", 
												width: "40px",
												border: '2px solid white',
												boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
											}}
										/>
									} 
									id="navbarScrollingDropdown"
									align="end"
								>
									<NavDropdown.Item disabled style={{ color: "#333", fontWeight: '500' }}>
										{userProfile.name}
									</NavDropdown.Item>
									<NavDropdown.Item disabled style={{ color: "#666", fontSize: '13px' }}>
										{userProfile.email}
									</NavDropdown.Item>
									<NavDropdown.Divider />
									<NavDropdown.Item>
										<GoogleLogout 
											clientId={goggleAuthClientID} 
											buttonText="Logout" 
											onLogoutSuccess={logoutFunction}
										/>
									</NavDropdown.Item>
								</NavDropdown>
							</div>
						</>
					) : (
						<GoogleLogin 
							clientId={goggleAuthClientID}
							buttonText="Sign in with Google"
							onSuccess={onAuthSuccess}
							onFailure={onAuthFailure}
							cookiePolicy={"single_host_origin"}
							isSignedIn={true}
						/>
					)}
				</Container>
			</Navbar>

			<ConfirmNavigationDialog
				isOpen={showConfirmDialog}
				onCancel={() => setShowConfirmDialog(false)}
				onConfirm={() => {
					setShowConfirmDialog(false);
					navigate('/saved-maps');
				}}
			/>
		</>
	);
};

export default NavigationBar;